import React, { useState } from 'react';
import { EditableList, Input } from '../index';
import { Row, AutoComplete, Icon, Input as AntInput } from 'antd';
import './Certification.css';
import PropTypes from 'prop-types';
import { getSkillCertList } from '../../../../services/Dashboard';
import { debounce } from 'lodash';
import { SEGMENTIO } from '../../../constants/segmentio';

function Certification (props) {
  const handleValidation = (item) => {};

  return (
    <EditableList
      {...props}
      onChange={props.onChange}
      textAddButton="Add cert. or award"
      addEvent={SEGMENTIO.PROFILE_ADD_CERT_AWARD_EVENT_CLICKED}
      cancelEvent={SEGMENTIO.PROFILE_CANCEL_CERT_AWARD_EVENT_CLICKED}
      saveEvent={SEGMENTIO.PROFILE_SAVE_CERT_AWARD_EVENT_CLICKED}
      dataSource={props.certifications || []}
      allowAdd
      addTitle="Add a new certification or award"
      editTitle="Update certification or award"
      validation={handleValidation}
      renderForm={(item) => (
        <CertificationForm
          {...item}
          allCertifications={props.allCertifications}
        />
      )}
      renderItem={(item, i) => <CertificationItem {...item} key={i} />}
    />
  );
}

function searchCertifications (value, callback) {
  if (!value || `${value}`.length < 3) {
    // eslint-disable-next-line standard/no-callback-literal
    return callback && callback([]);
  } else {
    getSkillCertList({
      action: 'GET_SKILLS_CERTIFICATION_LIST',
      field: 'certifications',
      value: value,
      searchId: null
    })
      .then(response => response.data)
      .then(({ success, result }) => success ? callback(result) : null);
  }
}
const debouncedSearchCertifications = debounce(searchCertifications, 1000);

const CertificationForm = React.memo((props) => {
  const year = new Date().getFullYear();

  const handleCertChange = (value) => {
    if (typeof value === 'object') {
      props.set({
        name: value.name,
        certification_id: value.id ? +value.id : null
      });
    }
  };

  const handleReadCertValue = (value) => {
    return {
      name: props.name,
      id: props.certification_id ? props.certification_id.toString() : null
    };
  };

  const SelectCertification = React.useMemo(
    () => (args) => {
      const [allCertifications, setAllCertifications] = useState([]);
      const certList = (allCertifications || []).map((cert) => (
        <AutoComplete.Option key={cert.id} value={cert.id.toString()}>
          {cert.name}
        </AutoComplete.Option>
      ));
      const getIdOfName = (name) => {
        debouncedSearchCertifications(name, result => {
          setAllCertifications(result);
          const selectedCert = result.find(cert => cert.name === name);
          if (selectedCert) {
            args.onChange({ name, id: selectedCert.id });
          }
        });
        const item = (allCertifications || []).find(
          (cert) => cert.name === name
        );
        if (item) return item.id;
        return null;
      };
      const getNameOfId = (id) => {
        const item = (allCertifications || []).find(
          (cert) => +cert.id === +id
        );
        if (item) return item.name;
        return '';
      };
      return (
        <AutoComplete
          value={args.value && args.value.name}
          onChange={(name) => args.onChange({ name, id: getIdOfName(name) })}
          onSelect={(id) => args.onChange({ name: getNameOfId(id), id })}
          dataSource={certList}
          placeholder="Enter minimum 3 characters to search or add custom certification"
          optionFilterProp="children"
          filterOption={(input, option) => {
            let value = '';
            if (typeof option.props.children === 'string') {
              value = option.props.children;
            } else if (typeof option.props.label === 'string') {
              value = option.props.label;
            } else if ('value' in option.props) {
              value = `${option.props.value}`;
            }
            return value.toLowerCase().indexOf(input.toLowerCase()) >= 0;
          }}
        >
          <AntInput
            suffix={<Icon type="search" className="certain-category-icon" />}
          />
        </AutoComplete>
      );
    },
    []
  );

  return (
    <Row gutter={[12, 0]}>
      <Input
        span={24}
        {...props.bind('certification', {
          onChange: handleCertChange,
          onReadValue: handleReadCertValue
        })}
        label="Name"
        placeholder="Name"
        component={SelectCertification}
      />
      <Input.Select
        span={24}
        {...props.bind('year')}
        label="Year"
        placeholder="Year"
        options={[...new Array(50)].map((v, i) => ({
          value: year - i,
          label: year - i
        }))}
      />
    </Row>
  );
});

const CertificationItem = React.memo((props) => {
  return (
    <div className="certification-item">
      <small>{props.year}</small>
      <h3>{props.name}</h3>
    </div>
  );
});

CertificationForm.propTypes = {
  allCertifications: PropTypes.array,
  set: PropTypes.func,
  certification_id: PropTypes.any,
  bind: PropTypes.func,
  name: PropTypes.any
};

Certification.propTypes = {
  onChange: PropTypes.func,
  certifications: PropTypes.array,
  allCertifications: PropTypes.array
};

CertificationItem.propTypes = {
  name: PropTypes.any,
  year: PropTypes.any
};

export default Certification;
